import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'dr-ops-stream-ui-forbidden',
  standalone: true,
  template: `
    <div class="forbidden">
      <h1>403 — Access denied</h1>
      <p>Your user is not provisioned in OpsStream. Contact an administrator to get access.</p>
    </div>
  `,
  styles: [`.forbidden{display:flex;flex-direction:column;align-items:center;justify-content:center;height:60vh;gap:.5rem;text-align:center}`],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ForbiddenComponent {}
